angular
    .module(ApplicationConfiguration.applicationModuleName)
    .directive("notificationPortal", function ($timeout) {
        return {
            restrict: "E",
            scope: {
                notifications: '<',
                isVisible: '='
            },
            templateUrl: "/modules/Commom/core/views/notification.list.html",
            controller: function ($scope, $state, Alerts, MessageService) {
                $scope.loading = true;

                $scope.updateNotificationCount = function () {
                    Alerts.updateCount()
                };


                $scope.getNotificationCount = function () {
                    return Alerts.notificationCount;
                }

                $scope.loadNotifications = function () {
                    $scope.loading = true;
                    Alerts.list().$promise.then(function (response) {
                        $scope.notifications = response.rows
                        $scope.updateNotificationCount();
                        $scope.loading = false;
                    }, function (error) {
                        $scope.loading = false;
                        MessageService.alertError(error.data);
                    });
                };

                $scope.loadNotifications();

                $scope.$watch("isVisible", function (newValue, oldValue) {
                    if (newValue === true) {
                        $scope.loadNotifications();
                    }
                });

                $scope.markAsRead = function (alertGuid) {
                    Alerts.read({ alertGuid: alertGuid }).$promise.then(function (response) {
                        $scope.loadNotifications();
                    }, function (error) {
                        MessageService.alertError(error.data);
                    });
                }

                $scope.markAllAsRead = function () {
                    Alerts.readAll().$promise.then(function (response) {
                        $scope.loadNotifications();
                    }, function (error) {
                        MessageService.alertError(error.data);
                    });
                }

                $scope.deleteNotification = function (alertGuid) {
                    Alerts.delete({ alertGuid: alertGuid }).$promise.then(function (response) {
                        $scope.loadNotifications();
                        Alerts.updateCount();
                    }, function (error) {
                        MessageService.alertError(error.data);
                    });
                }

                $scope.notificationDetails = function (moduleId) {
                    switch (moduleId) {
                        case 'Colors':
                            return { link: 'main.colorrequest-edit' }
                        case 'BonusesAndSponsorships':
                            return { link: 'main.bonuses' }
                        case 'SWFlow':
                            return { link: 'main.promotionrequest-edit' }
                        default:
                            return {
                                link: null
                            }
                    }
                }

                $scope.redirectTo = function (link, alertTarget) {
                    if (link) {
                        $state.go(link, { id: alertTarget });
                        $scope.isVisible = false;
                    }
                }


                $scope.formatElapsedTime = function (inputDate) {
                    const date = new Date(inputDate);

                    const localTime = date.getTime();

                    const timezoneOffset = date.getTimezoneOffset() * 60000;

                    const localDate = new Date(localTime - timezoneOffset);

                    const formattedLocalDate = localDate.toLocaleString();

                    return formattedLocalDate;
                };
            },
        };
    });